var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"graphics-loader"},[_vm._v(" Graphics: "),_c('div',[_c('input',{ref:"input",attrs:{"type":"file","accept":"image/*, application/pdf, application/postscript","multiple":"true"},on:{"change":_vm.addFiles}})])])}
var staticRenderFns = []

export { render, staticRenderFns }